/*
 * SS-CUSTOM: pack calculator
 * Floor size to pack count on a range collection page. Whole tiles along each side of each area,
 * so a tile cut at a wall counts whole; the areas' tiles are added, then rounded up to full packs.
 * Sizes go to whole millimetres before any division, so 6 m is 15 tiles of 400 mm, never 16.
 * No allowance is added, so the figure reconciles with the cart.
 */
(function () {
'use strict';

var MONEY = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

function wire(root) {
  var result = root.querySelector('[data-ss-packcalc-result]');
  var areas = root.querySelectorAll('[data-ss-packcalc-area]');
  var add = root.querySelector('[data-ss-packcalc-add]');
  if (!result || !areas.length) return;

  var tileLength = parseInt(root.dataset.tileLength, 10);
  var tileWidth = parseInt(root.dataset.tileWidth, 10);
  var packTiles = parseInt(root.dataset.packTiles, 10);
  var packPrice = parseInt(root.dataset.packPrice, 10);
  if (!tileLength || !tileWidth || !packTiles) return;

  function mm(input) {
    return Math.round((parseFloat(input.value) || 0) * 1000);
  }

  // a long tile is laid the way that takes fewer
  function tilesFor(area) {
    var width = mm(area.querySelector('[data-ss-packcalc-width]'));
    var length = mm(area.querySelector('[data-ss-packcalc-length]'));
    if (width <= 0 || length <= 0) return 0;
    return Math.min(
      Math.ceil(width / tileWidth) * Math.ceil(length / tileLength),
      Math.ceil(width / tileLength) * Math.ceil(length / tileWidth)
    );
  }

  function render() {
    var tiles = 0;
    areas.forEach(function (area) {
      if (!area.hidden) tiles += tilesFor(area);
    });
    if (tiles <= 0) {
      result.textContent = '';
      return;
    }

    var packs = Math.ceil(tiles / packTiles);
    var copy = tiles + ' tiles → <b>' + packs + (packs === 1 ? ' pack</b>' : ' packs</b>');

    if (packPrice > 0) copy += ' · from ' + MONEY.format((packs * packPrice) / 100);
    result.innerHTML = copy;
  }

  if (add) {
    add.addEventListener('click', function () {
      var next = root.querySelector('[data-ss-packcalc-area][hidden]');
      if (!next) return;
      next.hidden = false;
      next.querySelector('input').focus();
      add.hidden = !root.querySelector('[data-ss-packcalc-area][hidden]');
      render();
    });
  }

  root.querySelectorAll('[data-ss-packcalc-remove]').forEach(function (button) {
    button.addEventListener('click', function () {
      var area = button.closest('[data-ss-packcalc-area]');
      area.hidden = true;
      area.querySelectorAll('input').forEach(function (input) {
        input.value = '';
      });
      if (add) {
        add.hidden = false;
        add.focus();
      }
      render();
    });
  });

  root.querySelectorAll('[data-ss-packcalc-width], [data-ss-packcalc-length]').forEach(function (input) {
    input.addEventListener('input', render);
  });
  render();
}

document.querySelectorAll('[data-ss-packcalc]').forEach(wire);

document.addEventListener('shopify:section:load', function (event) {
  event.target.querySelectorAll('[data-ss-packcalc]').forEach(wire);
});
})();
